__turbopack_context__.v({
  "future": "BoardSectionItemsBR24Rundschau-module-scss-module__g--3dW__future",
  "status": "BoardSectionItemsBR24Rundschau-module-scss-module__g--3dW__status",
  "title": "BoardSectionItemsBR24Rundschau-module-scss-module__g--3dW__title",
});
